import type { MenuProps } from 'antd';
import { mdCanReadModule, type AppModule } from '@stores/modulePermissions';
import { mdGetAllowedDashboardTabs } from '@modules/dashboard/dashboardAccess';

// Пункт меню → модуль AppPermissions; пункти без запису (налаштування) доступні всім
const MD_MENU_MODULES: Record<string, AppModule> = {
  warehouse: 'WMS',
  'dict-products': 'Products',
  'dict-units': 'Products',
  'dict-suppliers': 'Suppliers',
  'dict-customers': 'Customers',
  'purch-orders': 'Purchases',
  'sales-orders': 'Sales',
  'fin-invoices': 'Finance',
  'fin-ar': 'Finance',
  'svc-equipment': 'InstalledBase',
  'svc-requests': 'ServiceRequests',
  'svc-sla': 'ServiceRequests',
  'reg-documents': 'Products',
  'reg-recalls': 'Products',
  'reg-vigilance': 'Products',
};

export function mdFilterMenuByRoles(mdItems: MenuProps['items'], mdUserRoles: readonly string[]): MenuProps['items'] {
  return (mdItems ?? []).flatMap((mdItem) => {
    if (!mdItem || !('key' in mdItem)) return [mdItem];
    const mdModule = MD_MENU_MODULES[String(mdItem.key)];
    if (mdModule && !mdCanReadModule(mdUserRoles, mdModule)) return [];
    // Дашборд — набір панелей з різних модулів: пункт потрібен, якщо доступна хоч одна
    if (mdItem.key === 'dashboard' && mdGetAllowedDashboardTabs(mdUserRoles).length === 0) return [];
    if ('children' in mdItem && Array.isArray(mdItem.children)) {
      const mdChildren = mdFilterMenuByRoles(mdItem.children, mdUserRoles);
      // Розділ без жодного доступного підпункту не показуємо
      return mdChildren && mdChildren.length > 0 ? [{ ...mdItem, children: mdChildren }] : [];
    }
    return [mdItem];
  });
}
